import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/ubo/:id',
    component: () => import('@/components/Client/UboRegistration/UboRegistrationView.vue'),
    name: 'ubo-client-details',
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
        dossier: 'client',
    },
} as RouteRecordRaw;
